import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';
import {ReadyForPickupComponent} from '@app/my-account/holds/ready-for-pickup/ready-for-pickup.component';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {PaginationSelectors, TableDefinition} from '@store/aviary/aviary.adapter';
import {Hold} from '@store/holds/holds.types';
import {getHoldsTableColumnsDefinition, ON_HOLD_TABLE_RESPONSIVE_DEFINITION} from '@app/my-account/holds/holds.constants';
import {TableComponent} from '@aviary/components/table/table.component';

@Component({
  selector: 'px-dependent-holds',
  template: `
    @let loaded = selectors.loaded | select:false;
    <div class="w-full px-0 md:px-6 py-5 flex flex-col gap-y-7">
      @if (readyForPickupSelectors.hasItemsReadyForPickup | select) {
        <div>
          <p class="pb-0 text-headline-small lg:text-headline-medium">Ready for Pickup ({{ readyForPickupSelectors.totalCount | select }})</p>
          <px-ready-for-pickup [forDependent]="true"/>
        </div>
      }
      <div>
        <p class="pb-0 text-headline-small lg:text-headline-medium">On Hold ({{ paginationSelectors.totalCount | select }})</p>
        <mx-table [tableDefinition]="onHoldTableDefinition" mxHiddenUntilLoaded [reveal]="loaded"/>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectPipe, HiddenUntilLoadedDirective, ReadyForPickupComponent, TableComponent]
})
export class DependentHoldsComponent {
  public readonly selectors = HoldsSelectors.DependentOnHold;
  public readonly readyForPickupSelectors = HoldsSelectors.DependentReadyForPickup;
  public readonly paginationSelectors = PaginationSelectors;

  public readonly onHoldTableDefinition: TableDefinition<Hold, typeof HoldsSelectors.DependentOnHold> = {
    defaultSelectorContainer: HoldsSelectors.DependentOnHold,
    dataSource: 'holds',
    responsiveColumnsDefinition: ON_HOLD_TABLE_RESPONSIVE_DEFINITION,
    columns: getHoldsTableColumnsDefinition(false)
  };
}
